"use client";

import { useQuery, keepPreviousData } from "@tanstack/react-query";

export interface VaultDetailsDto {
  vault?: {
    id: string;
    slug?: string;
    organizationUrlSlug?: string;
    visibility?: "private" | "protected" | "org" | "public";
    repoUrl?: string | null;
    mode?: string | null;
    detectedSourceWiki?: string | null;
  } | null;
}

export function useVaultDetailsQuery(vaultId?: string | null) {
  return useQuery<VaultDetailsDto>({
    queryKey: ["vault", vaultId],
    enabled: Boolean(vaultId),
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const res = await fetch(`/api/vaults/${vaultId}`, { cache: "no-store" });
      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        throw new Error(txt || `Failed to load vault ${vaultId}`);
      }
      return (await res.json()) as VaultDetailsDto;
    },
    staleTime: 5 * 60_000,
  });
}

